import { setListener } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import { forEach } from 'lodash-es';

export default createComponent(() => ({
    label: document.querySelector('.js-file-label') as HTMLInputElement,
    input: document.querySelector('.js-file-input') as HTMLInputElement,

    upload() {
        if (this.input.files?.length) {
            let name = '';
            forEach(this.input.files, (item) => {
                name += item.name+' ';
            })

            this.label.placeholder = name;
        } else {
            this.input.value = "";
            this.label.placeholder = "";
        }
    },
}));